import { arrayify } from '~/components/util'

export const onRest = (rests: string | string[], callback: (rest: string) => any) => {
  const restTypes = arrayify(rests)

  onBodyEvent('CounterReset', (ev: CustomEvent) => {
    const type = ev?.detail?.type
    if (restTypes.includes(type)) {
      callback(type)
    }
  })
}
